module.exports = __webpack_public_path__ + "fonts/Raleway-Regular.580d0778.ttf";